// extracted by mini-css-extract-plugin
export default {"newBookingWrapper":"NewBooking_newBookingWrapper__nKPK4","bookings":"NewBooking_bookings__q7U3X","myBookings":"NewBooking_myBookings__r3FHt"};